import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addMaterialPersonel } from "../api/addMaterialPersonel";

export const useAddMaterialPersonel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => addMaterialPersonel(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["materialPersonel"] });
    },
  });
};

